import { C49ClickablePhotoContentWrapperProps } from './C49ClickablePhotoContentWrapper.types';
import {
  ClickablePhotoContentCard,
  ClickablePhotoContentCarouselProps,
} from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { CLICKABLE_PHOTO_CONTENT_CARD_COMPONENT_NAME } from '@/shared/static';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { C49ClickablePhotoContentCardProps } from './C49ClickablePhotoContentCard.types';
import { CreateC49ClickablePhotoContentCardModel } from './C49ClickablePhotoContentCard.service';

export function CreateC49ClickablePhotoContentWrapperModel(
  props?: C49ClickablePhotoContentWrapperProps
): ClickablePhotoContentCarouselProps {
  const { renderText, renderRichText, renderLink } = useConditionalRendering();
  const { params, fields } = props || {};

  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  const slidesArray = isEditing
    ? []
    : props?.rendering?.placeholders?.['clickable-photo-content-card-container-{*}']?.filter(
        ({ componentName }) =>
          !!componentName && componentName === CLICKABLE_PHOTO_CONTENT_CARD_COMPONENT_NAME
      ) || [];

  const slides =
    slidesArray?.map((s, idx) => {
      const cta = s as unknown as C49ClickablePhotoContentCardProps;

      return (
        <ClickablePhotoContentCard
          key={idx}
          {...CreateC49ClickablePhotoContentCardModel({
            props: cta,
            isEditing: sitecoreContext?.pageEditing || false,
          })}
          data-component={marketingRenderingName}
          shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
        />
      );
    }) || [];

  const carouselProps = {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    contentAlignment: getDroplink(params?.ContentAlignment, 'left'),
    cta: renderLink(fields?.CTA),
    backgroundColor: getDroplink(params?.BackgroundColor, 'white'),
    headlineTag: getDroplink(params?.HeadlineTag, 'h2'),
    ctaStyle: getDroplink(params?.CTAStyle, 'outlined-alt'),
    slides: slides,
  } as ClickablePhotoContentCarouselProps;

  return carouselProps;
}
